interface Props {
  errorMessages?: string[];
  messageType?: 'error' | 'success' | 'fail';
}

export default function ErrorList({ errorMessages, messageType = 'error' }: Props) {
  if (!errorMessages || errorMessages.length === 0) {
    return null;
  }
  return (
    <ul className={`${messageType}List`}>
      {errorMessages.map((text) => <li key={text}>{text}</li>)}
    </ul>
  );
}
